import {
    Component,
    Input,
    Output,
    EventEmitter,
    ViewChild,
    AfterViewChecked
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { PartieDepot, QualityType } from '../../../../../entities/requete';
import { AccountType, ScrollToService } from '../../../../../shared';
import { ErrorService } from '../../../../../shared/services/error.service';

@Component({
    selector: 'jhi-edit-form',
    templateUrl: './edit-form.component.html',
    styleUrls: ['./edit-form.component.scss']
})
export class EditFormComponent implements AfterViewChecked {
    identityType: AccountType = AccountType.PHYSIQUE;

    AccountTypeEnum = AccountType;

    @Input()
    requerant: PartieDepot;

    @Output() onAddRequerant = new EventEmitter<PartieDepot>();

    @ViewChild(NgForm)
    private form: NgForm;

    displayEditForm = false;

    private enableScroll: boolean;

    constructor(private errorService: ErrorService, private scrollService: ScrollToService) {}

    ngAfterViewChecked(): void {
        if (this.enableScroll) {
            this.scrollService.scrollToFirstError();
            this.enableScroll = false;
        }
    }

    addRequerant() {
        if (this.form.valid) {
            this.onAddRequerant.emit(this.requerant.clone());
        } else {
            this.errorService.markAllControlsAsTouched(this.form);
            this.enableScroll = true;
        }
    }

    addNewRequerant() {
        this.initRequerant();
        this.displayEditForm = true;
    }

    initRequerant() {
        this.requerant = new PartieDepot();
        this.requerant.type = this.identityType;
        this.requerant.qualite = QualityType.Requerant;
    }

    close() {
        this.displayEditForm = false;
    }

    get isMoraleIdentity() {
        return this.identityType === AccountType.MORALE;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/steps/requerants/add-requerant-section/edit-form/edit-form.component.ts